export default __webpack_public_path__ + "assets/front/scss/editorial.83bd2b66b6dbfb6e25bb5bb786b82813.css";